import { render, staticRenderFns } from "./ECommerceTable.vue?vue&type=template&id=5b3cc534"
import script from "./ECommerceTable.vue?vue&type=script&lang=ts"
export * from "./ECommerceTable.vue?vue&type=script&lang=ts"
import style0 from "./ECommerceTable.vue?vue&type=style&index=0&id=5b3cc534&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports